import { render, staticRenderFns } from "./ReviewDetails.vue?vue&type=template&id=3a098f99&"
import script from "./ReviewDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports